import {
  SectionTitle,
  SectionSubtitle,
  SectionParagraph,
} from 'pages/static/section'
import { HeaderCentered } from '../styles'
import WhyBecomeAHost from '../../onboarding/WhyBecomeAHost'

const JoinUs = () => {
  return (
    <>
      <HeaderCentered>
        <SectionTitle>HOSTING</SectionTitle>

        <SectionSubtitle>Why become a Riparide Host?</SectionSubtitle>

        <SectionParagraph>
          We understand how unique your property is, and we want to help others
          experience its magic.
        </SectionParagraph>
      </HeaderCentered>

      <WhyBecomeAHost />
    </>
  )
}

export default JoinUs
